import { DynamicPropertyType } from 'types/DynamicPropertyType';

import UnitNumber from './UnitNumber';

export default class Percentage extends UnitNumber {
    type = DynamicPropertyType.PERCENTAGE;
    unit = '%';
}
